export const IMAGES = {
  hero: "https://images.pexels.com/photos/9490654/pexels-photo-9490654.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  worldNight:
    "https://images.unsplash.com/photo-1769251968740-f8ffa70f9043?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxlYXJ0aCUyMG5pZ2h0JTIwZnJvbSUyMHNwYWNlfGVufDB8fHx8MTc4ODYwMDQxMnww&ixlib=rb-4.1.0&q=85",
  agriculture:
    "https://images.unsplash.com/photo-1560493676-04071c5f467b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwxfHxwcmVtaXVtJTIwYWdyaWN1bHR1cmUlMjBmaWVsZHxlbnwwfHx8fDE3ODg2MDA0MjF8MA&ixlib=rb-4.1.0&q=85",
  dubai:
    "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwxfHxkdWJhaSUyMHNreWxpbmUlMjBtb2Rlcm58ZW58MHx8fHwxNzg4NTk0MTczfDA&ixlib=rb-4.1.0&q=85",
  mumbai:
    "https://images.pexels.com/photos/5414582/pexels-photo-5414582.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  jakarta:
    "https://images.unsplash.com/photo-1718729362445-51d2da1ee7a7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxqYWthcnRhJTIwc2t5bGluZXxlbnwwfHx8MTc4ODYwMDQxMnww&ixlib=rb-4.1.0&q=85",
  warehouse:
    "https://images.unsplash.com/photo-1761472651462-c2a019e76f4b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxwcmVtaXVtJTIwZm9vZCUyMHdhcmVob3VzZXxlbnwwfHx8MTc4ODYwMDQxMnww&ixlib=rb-4.1.0&q=85",
  retail:
    "https://images.unsplash.com/photo-1583258292688-d0213dc5a3a8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHw0fHxwcmVtaXVtJTIwcmV0YWlsJTIwc3RvcmUlMjBmb29kfGVufDB8fHwxNzg4NjAwNDEyfDA&ixlib=rb-4.1.0&q=85",
  spices:
    "https://images.unsplash.com/photo-1581600140682-d4e68c8cde32?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwyfHxwcmVtaXVtJTIwc3BpY2VzJTIwaW5ncmVkaWVudHN8ZW58MHx8fHwxNzg4NTk0MTYxfDA&ixlib=rb-4.1.0&q=85",
  amazon:
    "https://images.unsplash.com/photo-1774830970925-e176508dc0ab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwzfHxhbWF6b24lMjByYWluZm9yZXN0JTIwYWVyaWFsfGVufDB8fHx8MTc4ODU5NDE2MXww&ixlib=rb-4.1.0&q=85",
  catFood:
    "https://images.unsplash.com/photo-1695649912699-435a5bc20203?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHw0fHxwcmVtaXVtJTIwY2hvY29sYXRlJTIwdHJ1ZmZsZXN8ZW58MHx8fHwxNzg4ODQ2MjEwfDA&ixlib=rb-4.1.0&q=85",
  catNatural:
    "https://images.unsplash.com/photo-1493925410384-84f842e616fb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxyYXclMjBjYWNhbyUyMG51dHMlMjBzcGljZXN8ZW58MHx8fHwxNzg4ODQ2MjEwfDA&ixlib=rb-4.1.0&q=85",
  catFunctional:
    "https://images.unsplash.com/photo-1708573106044-2bbefb3d9fc3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwyfHxzdXBlcmZvb2QlMjBtYXRjaGElMjB3ZWxsbmVzc3xlbnwwfHx8fDE3ODg4NDYyMTB8MA&ixlib=rb-4.1.0&q=85",
  catFoodservice:
    "https://images.unsplash.com/photo-1663530761401-15eefb544889?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwzfHxnb3VybWV0JTIwcmVzdGF1cmFudCUyMHBsYXRpbmd8ZW58MHx8fHwxNzg4ODQ2MjEwfDA&ixlib=rb-4.1.0&q=85",
  catPremium:
    "https://images.unsplash.com/photo-1762926627902-c0846725e69e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxnb3VybWV0JTIwZm9vZCUyMHJldGFpbCUyMHByZW1pdW0lMjBzaGVsdmVzfGVufDB8fHwxNzg4ODQ3Njc2fDA&ixlib=rb-4.1.0&q=85",
  catPrivate:
    "https://images.unsplash.com/photo-1530037335614-e68828dcf258?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBjbGVhbiUyMGJvdHRsaW5nJTIwcGxhbnR8ZW58MHx8fHwxNzg4ODQ2MjEwfDA&ixlib=rb-4.1.0&q=85",
  trade:
    "https://images.unsplash.com/photo-1590496793907-4d66e2994b4d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwyfHxhZXJpYWwlMjBjb250YWluZXIlMjBwb3J0JTIwZHVza3xlbnwwfHx8fDE3ODg4NDY4ODV8MA&ixlib=rb-4.1.0&q=85",
  logistics:
    "https://images.unsplash.com/photo-1553413077-190dd305871c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBsb2dpc3RpY3MlMjBkaXN0cmlidXRpb24lMjB3YXJlaG91c2V8ZW58MHx8fDE3ODg4NDY4ODV8MA&ixlib=rb-4.1.0&q=85",
  commerce:
    "https://images.unsplash.com/photo-1786301326154-3e040dc8db60?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHw0fHxzcGljZSUyMG1hcmtldCUyMHNhY2tzJTIwb2YlMjBncmFpbnN8ZW58MHx8fHwxNzg4ODQ3NjcwfDA&ixlib=rb-4.1.0&q=85",
  asia:
    "https://images.unsplash.com/photo-1717386255773-1e3037c81788?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBlbGVjdHJvbmljcyUyMG1hbnVmYWN0dXJpbmclMjBmYWNpbGl0eXxlbnwwfHx8fDE3ODg4NDY4ODV8MA&ixlib=rb-4.1.0&q=85",
};

export const CAPABILITIES = [
  {
    title: "International Sourcing",
    text: "Identification and development of manufacturers, producers and brands across international sourcing markets.",
  },
  {
    title: "Import & Procurement",
    text: "Structured procurement and importing of selected international products into our destination markets.",
  },
  {
    title: "Market Development",
    text: "Destination-market strategy, channel development and regional commercialisation across our territories.",
  },
  {
    title: "Private Label",
    text: "Private-label sourcing, contract manufacturing and customised product development for individual markets.",
  },
];

export const MARKETS = [
  {
    num: "01",
    region: "Middle East",
    name: "Middle East",
    text: "The Middle East forms a core market within RSC Imports' regional procurement and distribution strategy. The region continues to demonstrate strong demand for premium international foods, speciality ingredients, functional products, consumer brands and differentiated product categories.",
    footer: "GCC & Wider Middle East",
    image: IMAGES.dubai,
    channels: [
      "Premium supermarkets",
      "Speciality retail",
      "Foodservice",
      "Hotels & hospitality",
      "E-commerce",
      "Wholesale distribution",
      "Ingredient distribution",
      "Corporate procurement",
    ],
  },
  {
    num: "02",
    region: "India",
    name: "India",
    text: "India is one of RSC Imports' principal strategic consumer markets. Rapid premiumisation, modern retail expansion and changing consumer preferences continue to create opportunities for differentiated international products and emerging categories.",
    footer: "High-Growth Consumer Market",
    image: IMAGES.mumbai,
    channels: [
      "Modern retail",
      "Premium supermarkets",
      "E-commerce",
      "Speciality stores",
      "Foodservice",
      "Hospitality",
      "Ingredient distribution",
      "Private-label channels",
    ],
  },
  {
    num: "03",
    region: "Southeast Asia",
    name: "Indonesia & Southeast Asia",
    text: "Indonesia serves as RSC Imports' Southeast Asian base for regional sourcing and market development. The wider region provides access to large and rapidly evolving consumer markets with growing demand across premium retail, foodservice, ingredients and international consumer products.",
    footer: "Strategic Regional Base",
    image: IMAGES.jakarta,
    channels: [
      "Modern grocery",
      "Speciality retail",
      "Hospitality",
      "Foodservice",
      "E-commerce",
      "Wholesale",
      "Ingredient distribution",
      "Premium consumer channels",
    ],
  },
];

export const CATEGORIES = [
  {
    num: "01",
    title: "Food & Beverage",
    image: IMAGES.catFood,
    text: "Premium packaged foods, speciality beverages, confectionery, chocolate, sauces, condiments, snacks and differentiated international food products.",
    detail:
      "Typical interests include premium snacking, fine confectionery and chocolate, speciality coffee and tea, ambient and chilled packaged foods, and distinctive regional specialities suited to premium retail, modern trade and foodservice channels.",
  },
  {
    num: "02",
    title: "Natural Ingredients",
    image: IMAGES.catNatural,
    text: "Fruit products, botanical ingredients, natural extracts, concentrates, purees, powders, cacao, nuts, agricultural ingredients and speciality raw materials.",
    detail:
      "Suitable for food, beverage and wellness manufacturers, ingredient distributors and industrial buyers seeking consistent quality, full documentation and scalable supply.",
  },
  {
    num: "03",
    title: "Functional & Wellness",
    image: IMAGES.catFunctional,
    text: "Functional beverages, superfoods, plant-based products, wellness-oriented foods and emerging better-for-you consumer categories.",
    detail:
      "A priority category across our destination markets, where health-oriented consumption and premiumisation continue to reshape retail and foodservice demand.",
  },
  {
    num: "04",
    title: "Foodservice & Hospitality",
    image: IMAGES.catFoodservice,
    text: "Bulk ingredients, frozen products, concentrates, powders and speciality products suitable for restaurants, hospitality groups, food manufacturers and beverage companies.",
    detail:
      "Supply solutions for restaurant groups, hotels, catering companies, food manufacturers and beverage producers requiring consistent specification and reliable volumes.",
  },
  {
    num: "05",
    title: "Premium Consumer Products",
    image: IMAGES.catPremium,
    text: "Selected international products and brands with strong potential for premium retail, speciality distribution and high-growth consumer markets.",
    detail:
      "Products are assessed for brand positioning, packaging standards, pricing architecture and relevance to premium retail and speciality distribution environments.",
  },
  {
    num: "06",
    title: "Private Label & Contract Manufacturing",
    image: IMAGES.catPrivate,
    text: "Private-label products, contract manufacturing, customised product development and strategic procurement opportunities for individual markets.",
    detail:
      "From product adaptation and customised development through to full contract manufacturing programmes tailored to individual market requirements.",
  },
];

export const REGIONS = [
  { name: "Europe", note: "Established premium & speciality production" },
  { name: "Asia", note: "Manufacturing & consumer products" },
  { name: "Middle East", note: "Regional trade & ingredient supply" },
  { name: "Latin America", note: "Natural ingredients & emerging categories" },
  { name: "Africa", note: "Agricultural & raw ingredients" },
  { name: "Oceania", note: "Speciality & premium produce" },
];

export const INITIATIVES = [
  {
    tag: "Latin America & Amazon Basin",
    image: IMAGES.amazon,
    title: "Natural Ingredients & Emerging Food Categories",
    text: "RSC Imports is expanding its sourcing relationships across Latin America, including producers from the Amazon Basin. Areas of interest include tropical fruits, açaí, cupuaçu, cacao, speciality nuts, fruit powders, concentrates, natural ingredients, functional beverages and differentiated food products. We are particularly interested in export-ready producers capable of supporting scalable international distribution.",
  },
  {
    tag: "Asia",
    image: IMAGES.asia,
    title: "Consumer Products & Manufacturing",
    text: "RSC Imports continues to develop its supplier network across major Asian production markets for food, beverage, consumer products, private-label manufacturing and emerging product categories.",
  },
  {
    tag: "Europe & International Speciality Markets",
    image: IMAGES.retail,
    title: "Premium Brands & Speciality Products",
    text: "We source premium and differentiated products from established international markets where provenance, product quality, brand positioning and speciality manufacturing create strong destination-market opportunities.",
  },
];

export const STEPS = [
  {
    title: "Product Discovery",
    text: "We identify manufacturers, producers and brands capable of offering differentiated products with international potential.",
  },
  {
    title: "Commercial Evaluation",
    text: "Products are assessed against pricing, quality, packaging, shelf life, certifications, manufacturing capacity and overall market positioning.",
  },
  {
    title: "Regulatory Assessment",
    text: "We review destination-market considerations including import requirements, product registration, labelling, documentation and compliance.",
  },
  {
    title: "Market Selection",
    text: "Not every product belongs in every market. We determine where the strongest commercial opportunity exists across our target territories.",
  },
  {
    title: "Commercial Validation",
    text: "Where appropriate, opportunities may progress through samples, product evaluation, market testing and initial procurement discussions.",
  },
  {
    title: "Import & Distribution Development",
    text: "Suitable products can progress toward structured importing, wholesale distribution, retail placement, foodservice, private label or strategic distribution partnerships.",
  },
  {
    title: "Regional Expansion",
    text: "Products demonstrating strong potential in one territory may subsequently be considered for additional RSC markets.",
  },
];

export const CHECKLIST = [
  "Consistent product quality",
  "Reliable manufacturing capacity",
  "Competitive export pricing",
  "International packaging standards",
  "Suitable shelf life",
  "Export documentation capability",
  "Traceability",
  "Relevant certifications",
  "Scalable production",
  "Commercial flexibility",
  "Professional communication",
  "Long-term supply capability",
  "Private-label capability where applicable",
];

export const WHY = [
  {
    title: "Three Strategic Consumer Regions",
    text: "Commercial focus across the Middle East, India and Southeast Asia provides suppliers with exposure to diverse international market opportunities.",
  },
  {
    title: "Centralised International Sourcing",
    text: "RSC Imports manages international sourcing centrally while developing market-specific commercial strategies.",
  },
  {
    title: "Category Development",
    text: "We actively identify emerging product categories and differentiated products rather than limiting procurement to established commodities.",
  },
  {
    title: "Long-Term Supplier Relationships",
    text: "Our preferred model is to develop scalable commercial relationships with producers capable of supporting long-term international growth.",
  },
  {
    title: "Flexible Route to Market",
    text: "Depending on the product and territory, commercial opportunities may include importing, distribution, foodservice, retail, wholesale, private label and strategic channel partnerships.",
  },
];

export const ASSESSMENT = [
  "Quality",
  "Export pricing",
  "MOQ",
  "Manufacturing capability",
  "Certifications",
  "Shelf life",
  "Packaging",
  "Market positioning",
  "Regulatory compatibility",
  "Supply consistency",
  "Scalability",
  "Private-label capabilities",
];

export const PROVIDE_LIST = [
  "Company profile",
  "Product catalogue",
  "Export price list",
  "MOQ",
  "Production capacity",
  "Current export markets",
  "Product specifications",
  "Certifications",
  "Shelf life",
  "Packaging specifications",
  "Private-label capabilities",
  "Lead times",
  "Sample availability",
];

export const PRIORITIES = [
  "Food & beverage",
  "Natural ingredients",
  "Functional products",
  "Premium consumer products",
  "Hospitality and foodservice",
  "Private label",
  "Contract manufacturing",
  "Speciality international products",
];

export const NAV_LINKS = [
  { label: "About", to: "/about" },
  { label: "Global Sourcing", to: "/sourcing" },
  { label: "Categories", to: "/categories" },
  { label: "Markets", to: "/markets" },
  { label: "Procurement", to: "/procurement" },
  { label: "Suppliers", to: "/suppliers" },
];

export const PRESENCE = [
  {
    region: "Middle East",
    note: "Regional procurement and market development across the GCC and wider Middle East.",
  },
  {
    region: "India",
    note: "Strategic consumer market focus across premium retail and emerging categories.",
  },
  {
    region: "Indonesia & Southeast Asia",
    note: "Southeast Asian base for regional sourcing and market development.",
  },
];
